
import { EventEmitter } from '@angular/core';
import { Component, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

/**
 * Component for displaying the form in the workspace sidebar
 * One of the most used components on the application
 */
@Component({
  selector: 'app-workspace-form',
  templateUrl: 'workspace-form.component.html'
})

export class WorkspaceFormComponent {
  @Input() public form: UntypedFormGroup;
  @Input() public pageTitle: string;
  @Input() public isFormValid: boolean = true;
  @Input() public spinnerName: string;
  @Input() public formName: string;

  @Input() public submitButtonText: string;
  @Input() public cancelButtonText: string;

  @Output() public cancelButtonEvent: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() public submitButtonEvent: EventEmitter<UntypedFormGroup> = new EventEmitter<UntypedFormGroup>(null);

  constructor() {}

}
